var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterConnectionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 27,
    viewBox: "0 0 121 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M75.62,27H0V21.88H75.62a2.587,2.587,0,0,0,2.6-2.56V7.69A7.755,7.755,0,0,1,86.02,0H121V5.12H86.02a2.587,2.587,0,0,0-2.6,2.56V19.31A7.755,7.755,0,0,1,75.62,27Z",
    fill: "#6a7084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterConnectionOff);
export default __webpack_public_path__ + "static/media/water_connection_off.efb80972451d1faf6fb182aa56da93a8.svg";
export { ForwardRef as ReactComponent };